import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {MyPet} from 'components/Sharpet'
import {viewOnlyNoticeIsRecent} from 'utils/viewOnly'

// Every success toast is celebrated by the member's pet (a Shar-Pei for
// anyone without one). The toast's icon slot is 20px wide by default;
// .custom-toast-pet in index.scss lets it widen to the pet, and the toast
// grows taller to fit it.
const PetIcon = () => (
  <span className="-my-1 -ml-1 inline-flex w-[72px] shrink-0 justify-center">
    <MyPet size={72} animated={false} />
  </span>
)

export const notifySuccess = ({message, position}) => {
  toast.success(message, {
    icon: PetIcon,
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    className: 'custom-toast custom-toast-pet',
  })
}

export const notifyWarning = ({message, position}) => {
  toast.warning(message, {
    position: 'top-center',
    autoClose: 8000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    className: 'custom-toast',
  })
}

export const notifyErrorOccured = ({message, position}) => {
  // An investor's refused write already showed the view-only notice.
  if (viewOnlyNoticeIsRecent()) return
  toast.error(message ? message : 'An error occured. Please try again.', {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    className: 'custom-toast-error',
  })
}
